import * as _4 from 'lodash4';
export class APDataConfiguration implements ng.IServiceProvider {
  private APCONFIGDEFAULTS = {
    featureToggles: {},
    services: {
      appConfigModel: {
        isFeatureEnabled: APDataConfiguration.NOOP('appConfigModel.isFeatureEnabled')
      },
      appNotificationDelegate: {
        error: APDataConfiguration.NOOP('appNotificationDelegate.error')
      }
    }
  };
  private configuration: any;
  constructor() {
    this.configuration = _4.merge({}, this.APCONFIGDEFAULTS);
  }
  static NOOP(expectedFn: string) {
    return function academicPlanner_NOOP() {
      console.error('academic-planner injection does not exist: ' + expectedFn);
    };
  }
  configure(config: any) {
    if (!!config) {
      this.configuration = _4.merge({}, this.APCONFIGDEFAULTS, this.configuration, config);
    }

    return this.configuration;
  }

  public activate(config: any) {
    return this.configure(config);
  }

  public read() {
    return this.configuration;
  }

  public injectService($injector: any, serviceName: string) {
    return $injector.has(serviceName) ? $injector.get(serviceName) : undefined;
  }

  $get($q: any, $injector: any) {
    this.configure({
      featureToggles: {},
      services: {
        appNotificationDelegate: this.injectService($injector, 'appNotificationDelegate'),
        appConfigModel: this.injectService($injector, 'appConfigModel')
      }
    });

    return {
      configure: this.configure,
      activate: this.activate,
      read: this.read
    };
  }
}
angular.module('capability-ng-academic-planner').provider('ngAPDataConfiguration', APDataConfiguration);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/config/data_configuration.ts